import { useCallback, useRef, useState } from 'react'

// State for an activity block. Starts from what was saved (or done earlier
// this session) and reports every change to the player, which decides when
// the screen is complete.
const useBlockState = (initialState, onStateChange) => {
  const [state, setState] = useState(initialState)
  const latest = useRef(state)

  const update = useCallback(
    (change) => {
      const next = typeof change === 'function' ? change(latest.current) : change
      latest.current = next
      setState(next)
      onStateChange?.(next)
    },
    [onStateChange],
  )

  return [state, update]
}

export const shuffle = (items) => {
  const result = [...items]
  for (let i = result.length - 1; i > 0; i -= 1) {
    const j = Math.floor(Math.random() * (i + 1))
    ;[result[i], result[j]] = [result[j], result[i]]
  }
  return result
}

export default useBlockState
